import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const Settings = () => {
  return (
    <div>
      <Header />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Settings</h1>
        <Card>
          <CardHeader>
            <CardTitle>Appearance</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-center justify-between space-x-2">
              <Label htmlFor="theme-switch">
                <span className="font-semibold">Dark Mode</span>
                <p className="text-sm text-muted-foreground">
                  Enable or disable dark mode.
                </p>
              </Label>
              <Switch id="theme-switch" />
            </div>
          </CardContent>
        </Card>

        <Card className="mt-8">
          <CardHeader>
            <CardTitle>Notifications</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="flex items-center justify-between space-x-2">
              <Label htmlFor="email-notifications">
                <span className="font-semibold">Email Notifications</span>
                <p className="text-sm text-muted-foreground">
                  Receive email notifications for reminders and updates.
                </p>
              </Label>
              <Switch id="email-notifications" checked />
            </div>
            <div className="flex items-center justify-between space-x-2">
              <Label htmlFor="push-notifications">
                <span className="font-semibold">Push Notifications</span>
                <p className="text-sm text-muted-foreground">
                  Receive push notifications on your devices.
                </p>
              </Label>
              <Switch id="push-notifications" />
            </div>
          </CardContent>
        </Card>
        <div className="mt-8">
          <Button>Save Changes</Button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
